import { IPrice, IVipPrice } from '@/api/types/public';
import Image from '@/components/Image';
import PriceComponent from '@/components/Product/Price';
import { useAppNavigation } from '@/hooks/useAppNavigation';
import { useStore } from '@/providers/app-store-provider';
import { useTranslations } from '@/i18n/use-translations';
import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import usePageTrack from '../hooks/usePageTrack';

export interface IProduct {
  id?: number | string;
  short_name?: string;
  price_info: IPrice[];
  price_info_v0: IPrice[];
  price_info_v1: IPrice[];
  price_info_v2: IPrice[];
  price_info_v3: IPrice[];
  config_image?: string;
  config_video?: string;
  in_stock: string;
  status: number;
  name: string;
  [key: string]: any;
}

interface IProps {
  data: [IProduct, IProduct];
  index: number;
  reportProductExp: (product: IProduct, index: number, type?: 'exp' | 'click') => void;
  [key: string]: any;
}
export default function CollectionItemB({ data, index, reportProductExp }: IProps) {
  const waiMode = useStore((state) => state.waiMode);
  const inAppH5 = useStore((state) => state.inAppH5);
  const t = useTranslations('product');
  const [activeProduct, setActiveProduct] = useState(data[0]);
  const { productRef, productInView } = usePageTrack({});
  const hasReportedAnotherProduct = useRef(false);

  const { navigate } = useAppNavigation();

  const clickProduct = (e) => {
    reportProductExp(activeProduct, index, 'click');
    if (inAppH5) {
      e.preventDefault();
      navigate(`/goods-detail/${activeProduct.shop_sku}`);
    }
  };
  useEffect(() => {
    if (productInView) {
      reportProductExp(activeProduct, index);
    }
  }, [productInView]);

  useEffect(() => {
    // * pc端一个坑位有 2 个商品，如果只上报第一个，第二个没有上报,数据会失真
    if (hasReportedAnotherProduct.current || data.length < 2) return;
    if (activeProduct.id === data[1].id) {
      reportProductExp(activeProduct, index);
      hasReportedAnotherProduct.current = true;
    }
  }, [activeProduct]);
  return (
    <div className="flex-1">
      <Link
        href={`/goods-detail/${activeProduct.shop_sku}`}
        ref={productRef}
        onClick={clickProduct}
      >
        <Image
          src={activeProduct.config_image}
          width={597}
          height={597}
          alt={activeProduct.name}
          className="w-full"
        />
      </Link>
      <div className="text-[18px]/[22px] mt-[12px] mb-[10px] text-[#282828] font-be">
        {activeProduct.short_name}
      </div>
      <PriceComponent
        priceObject={activeProduct as IVipPrice}
        renderPrice={(price, sellPrice) => (
          <div className="mt-6 flex items-center">
            <span className="text-14 font-bb leading-[17px] notranslate">{sellPrice}</span>
            {price && (
              <span
                className={`ml-6 text-12 leading-[17px] line-through ${waiMode ? 'text-primary-black' : 'text-secondary-text'}`}
              >
                {price}
              </span>
            )}
          </div>
        )}
      />
      <div className="flex gap-[8px] mt-[16px]">
        {data.map((item, i) => {
          const isSoldOutOrNoRestock = item.in_stock !== '1' || item.status === 2;
          const isActive = item.shop_sku === activeProduct.shop_sku;
          return (
            <div
              key={item.shop_sku}
              className={`w-[86px] h-[86px] rounded-[3px] overflow-hidden flex justify-center  bg-[#eeeeee] border-[1px]  p-[25px_7px] relative ${isSoldOutOrNoRestock ? 'border-dashed border-[rgba(40,40,40,0.3)]' : !isActive && 'border-transparent'} ${isActive ? 'border-[#808080] border-solid' : `cursor-pointer ${isSoldOutOrNoRestock ? 'cursor-pointer' : 'border-transparent'}`}`}
              onMouseEnter={() => setActiveProduct(item)}
            >
              <div className="w-full h-full  rounded-[3px] overflow-hidden flex justify-center">
                <Link href={`/goods-detail/${item.shop_sku}`} onClick={clickProduct}>
                  <Image
                    src={item.image}
                    alt={`${item.short_name}/${i === 0 ? 'glasses' : 'sunglasses'}`}
                    width={72}
                    height={36}
                    sizes={'72px'}
                    className="w-full mix-blend-multiply"
                  />
                  {isSoldOutOrNoRestock && (
                    <div
                      className={`absolute top-0 right-0 ${'w-[80px] h-[20px] text-[12px]/[12px]'} bg-[#d4d4d4] text-[#808080] text-center rounded-tr-[4px] rounded-bl-[4px] cursor-pointer flex items-center justify-center font-normal`}
                    >
                      {item.in_stock === '2' ? t('soldOut.soldOut') : t('soldOut.noRestock')}
                    </div>
                  )}
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
